
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import { GelirGiderEntity } from "@/entity/GelirGiderEntity";
import GelirGiderTurPicker from "@/components/pickers/GelirGiderTurPicker.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import Kur from "@/components/inputs/Kur.vue";
import Dates from "@/components/inputs/Dates.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";

@Component({
  components: { Dates, Kur, ParaBirimiPicker, Tutar, GelirGiderTurPicker, FormWrapper }
})
export default class GelirGiderForm extends Mixins(ObjectInputMixin) {
  @Prop({ default: null }) gelirMi!: boolean | null;
  @Prop({ default: false }) isVisible!: boolean;

  localValue!: GelirGiderEntity;

  get isGelir(): boolean {
    return this.gelirMi !== null ? this.gelirMi : this.localValue.gelir_mi;
  }

  @Watch('gelirMi', { immediate: true })
  onGelirMiChange(newValue: boolean | null) {
    if (newValue !== null) {
      this.localValue.gelir_mi = newValue;
    }
  }

  async save() {
    let data: any = { ...this.localValue };
    
    // Create mode specific logic
    if (!this.localValue.id) {
       if (this.gelirMi !== null) {
         data.gelir_mi = this.gelirMi;
       }
       data.hesaba_eklensin_mi = true;
       data.kasa_id = 1;
    }

    if (this.localValue.id) {
      this.$http.put('/api/v1/kasa-hareketi/' + this.localValue.id, data).then(() => (this.$emit('onSuccess')));
    } else {
      this.$http.post('/api/v1/kasa-hareketi', data).then(() => (this.$emit('onSuccess')));
    }
  }
}
